import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=aeb2e6f0&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=aeb2e6f0&prod&scoped=true&lang=css"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=aeb2e6f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb2e6f0",
  null
  
)

export default component.exports